export default "__VITE_ASSET__D3JMoK5b__"